import { Modal } from "takeat-design-system-ui-kit";
import styled from "styled-components";

export const ModalUpdateZoopContainer = styled(Modal)`
  width: fit-content;
  height: fit-content;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;

  > main {
    display: flex;
    flex-direction: row;
    gap: 16px;

    > img {
      height: fit-content;
    }
  } 

  > footer {
    display: flex;
    flex-direction: row;
    gap: 8px;
    width: fit-content;
    margin-left: auto;
  }
`

export const ModalUpdateZoopTexts = styled.div`
  width: 462px;

  > h4 {
    color: var(--Takeat-Colors-Neutrals-Black-01, #222);
    font-family: Poppins;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
    letter-spacing: var(--Headline-Small-Tracking, 0);
  }

  p {
    color: #545454;
    font-family: Poppins;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: 0.1px;
    padding: 0;
  }

  > section {
    padding: 12px;

    span {
      color: #545454;
      font-weight: 700;
    }
  }
`